import _extends from "@babel/runtime/helpers/extends";
import { Box, FormField, RadioGroup, Text } from '@wix/design-system';
import React from 'react';
import { RuleListStatus } from '../../../types';
import { dataHooks } from '../../../utils/datahooks';
import { RuleFooter, RuleLayout } from '../../rule-layout';
import { RadioGroupFixerCompletedState } from './radio-group-completed-state';
import { useRadioGroupFixer } from './use-radio-group-fixer';
export const RadioGroupFixer = _ref => {
  let {
    ruleResult,
    selected,
    failedElementsComponent
  } = _ref;
  const {
    ruleFooterProps,
    selectedRadioOption,
    description,
    radioOptions,
    onChange,
    radioGroupLabel,
    isEditMode,
    onEditClick
  } = useRadioGroupFixer(ruleResult, selected);
  const design = ruleResult.fixerProps.design;
  return ruleResult.status === RuleListStatus.passed && !isEditMode ? /*#__PURE__*/React.createElement(RadioGroupFixerCompletedState, {
    description: description,
    ruleResult: ruleResult,
    onEditClick: onEditClick
  }) : /*#__PURE__*/React.createElement(RuleLayout, {
    description: description,
    design: design == null ? void 0 : design.ruleLayout
  }, /*#__PURE__*/React.createElement(FormField, {
    label: radioGroupLabel
  }, /*#__PURE__*/React.createElement(RadioGroup, {
    dataHook: dataHooks.radioGroupFieldRadioGroupFixer(ruleResult.dataHook),
    disabled: ruleFooterProps.submitButtonProps.showLoader,
    size: "small",
    value: selectedRadioOption == null ? void 0 : selectedRadioOption.value,
    onChange: onChange
  }, radioOptions.map(option => /*#__PURE__*/React.createElement(RadioGroup.Radio, {
    key: option.id,
    value: option.value
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, option.label)))), (selectedRadioOption == null ? void 0 : selectedRadioOption.optionElement) && /*#__PURE__*/React.createElement(Box, {
    dataHook: dataHooks.RadioGroupFixerSelectedOptionOptionElement(ruleResult.dataHook),
    marginTop: "SP1"
  }, selectedRadioOption.optionElement)), failedElementsComponent, /*#__PURE__*/React.createElement(RuleFooter, _extends({}, ruleFooterProps, {
    design: design == null ? void 0 : design.ruleFooter
  })));
};
//# sourceMappingURL=radio-group-fixer.js.map